module.exports = __webpack_public_path__ + "img/f2.7916c77d.png";